import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { ADD_BUNDLE_PRODUCT_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class AddBundleProduct extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = [];

  url = ADD_BUNDLE_PRODUCT_URL;

  constructor(applicationId, bundleProductId, demandProductId, applicantId) {
    super();

    this.body = {
      bundleProductId,
      parameters: {
        linkDebitCardToDemandProductId: demandProductId,
      },
      applicantId,
    };
    const paramList = [applicationId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
